module.exports = __webpack_public_path__ + "img/en_flag.8c4291d3.png";